<template>
  <div class="data-grid-wrapper">
    <slot :row-class-name="getRowClassName"/>
  </div>
</template>

<script>
import DataGridRow from './store/dataGridRow'
export default {
  name: 'DataGridWrapper',
  mixins: [DataGridRow],
  props: {
    gridConfig: {
      type: Object
    },
    rowList: {
      type: Array
    }
  },
  methods: {
    getRowClassName ({rowIndex}) {
      let rowClassName = this.rowClassName
      if (rowClassName) {
        return rowClassName[rowIndex]
      }
    }
  }
}
</script>

<style lang="scss">
  .data-grid-wrapper {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
  }
</style>
